"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _semanticUiReact = require("semantic-ui-react");

var _ImageBanner = _interopRequireDefault(require("../../molecules/ImageBanner"));

var _InternalLink = _interopRequireDefault(require("../../atoms/InternalLink"));

var _OutboundLink = _interopRequireDefault(require("../../atoms/OutboundLink"));

var _Map = _interopRequireDefault(require("../../atoms/Map"));

require("./HeroElement.css");

var _Event = _interopRequireDefault(require("../../darkmatter/Event"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  return function () {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var HeroElement = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(HeroElement, _React$Component);

  var _super = _createSuper(HeroElement);

  function HeroElement() {
    (0, _classCallCheck2["default"])(this, HeroElement);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(HeroElement, [{
    key: "getCTAProps",
    value: function getCTAProps(cta, index) {
      var color = cta.color,
          inverted = cta.inverted;
      var _this$props = this.props,
          ctaColor = _this$props.ctaColor,
          ctaInverted = _this$props.ctaInverted;
      var buttonColor = color === null || color === undefined ? {
        color: ctaColor
      } : {
        color: color
      };
      var buttonInverted = inverted === null || inverted === undefined ? {
        inverted: ctaInverted
      } : {};
      return _objectSpread({
        className: "cta-".concat(index)
      }, cta, {}, buttonColor, {}, buttonInverted);
    }
  }, {
    key: "getOverlayContainerStyle",
    value: function getOverlayContainerStyle() {
      var _this$props2 = this.props,
          containerAs = _this$props2.containerAs,
          containerColor = _this$props2.containerColor;
      if (containerAs === 'solid') return {
        backgroundColor: containerColor,
        opacity: 0.9
      };
      if (containerAs === 'outline') return {
        borderStyle: 'solid',
        borderColor: 'white'
      };
      return {};
    }
  }, {
    key: "getColumnStyle",
    value: function getColumnStyle(type, value) {
      var _this$props3 = this.props,
          height = _this$props3.height,
          textAlign = _this$props3.textAlign;
      var baseStyle = {
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: height,
        display: 'flex',
        alignItems: textAlign,
        justifyContent: 'center',
        padding: '1em'
      };
      return type === 'image' ? _objectSpread({}, baseStyle, {
        backgroundImage: "url('".concat(value, "')")
      }) : _objectSpread({}, baseStyle);
    }
  }, {
    key: "getBackgroundMetadata",
    value: function getBackgroundMetadata() {
      var _this$props4 = this.props,
          images = _this$props4.images,
          containerColor = _this$props4.containerColor,
          address = _this$props4.address,
          showMap = _this$props4.showMap;
      var displayMap = address && showMap || !images || images.length === 0;
      return {
        background: displayMap ? containerColor : images[0],
        content: displayMap ? /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            margin: '1em',
            padding: '0em'
          }
        }, /*#__PURE__*/_react["default"].createElement(_Map["default"], {
          address: address
        })) : null,
        type: 'image'
      };
    }
  }, {
    key: "requiresOverlay",
    value: function requiresOverlay() {
      var _this$props5 = this.props,
          images = _this$props5.images,
          overlay = _this$props5.overlay,
          address = _this$props5.address,
          showMap = _this$props5.showMap;
      if (!images || images === []) return false;
      return overlay && !(address && showMap);
    }
  }, {
    key: "requiresOnlyText",
    value: function requiresOnlyText() {
      var _this$props6 = this.props,
          images = _this$props6.images,
          address = _this$props6.address;
      return (!images || images === []) && !address;
    }
  }, {
    key: "renderCTA",
    value: function renderCTA(ctaProps) {
      var text = ctaProps.text,
          link = ctaProps.link,
          internal = ctaProps.internal,
          color = ctaProps.color,
          inverted = ctaProps.inverted,
          internalLinkComponent = ctaProps.internalLinkComponent,
          className = ctaProps.className;
      return internal ? /*#__PURE__*/_react["default"].createElement(_Event["default"], {
        event: {
          category: 'Hero CTAs',
          action: 'Click',
          label: text
        },
        eventType: "click"
      }, /*#__PURE__*/_react["default"].createElement(_InternalLink["default"], {
        as: internalLinkComponent || 'a',
        to: link,
        gatsbyLink: internalLinkComponent !== null && internalLinkComponent !== undefined,
        className: className
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
        style: {
          marginTop: '1em'
        },
        color: color,
        inverted: inverted
      }, text))) : /*#__PURE__*/_react["default"].createElement(_OutboundLink["default"], {
        style: {
          marginTop: '1em'
        },
        color: color,
        inverted: inverted,
        as: _semanticUiReact.Button,
        to: link,
        content: text,
        className: className
      });
    }
  }, {
    key: "renderCTAS",
    value: function renderCTAS() {
      var _this = this;

      var ctas = this.props.ctas;
      return /*#__PURE__*/_react["default"].createElement("div", null, ctas.map(function (cta, index) {
        return _this.renderCTA(_this.getCTAProps(cta, index));
      }));
    }
  }, {
    key: "renderHeaderContent",
    value: function renderHeaderContent() {
      var _this$props7 = this.props,
          header = _this$props7.header,
          tagline = _this$props7.tagline,
          ctas = _this$props7.ctas,
          textColor = _this$props7.textColor,
          textAlign = _this$props7.textAlign;
      var forceCenterAlign = this.requiresOverlay() || this.requiresOnlyText();
      var headerStyle = {
        padding: '1em',
        textAlign: forceCenterAlign ? 'center' : textAlign
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: headerStyle
      }, header && /*#__PURE__*/_react["default"].createElement("h1", {
        style: {
          color: textColor
        }
      }, header), tagline && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          color: textColor
        }
      }, tagline), ctas && ctas.length > 0 && this.renderCTAS(ctas));
    }
  }, {
    key: "renderOverlayContainer",
    value: function renderOverlayContainer() {
      var _this$props8 = this.props,
          containerAs = _this$props8.containerAs,
          containerColor = _this$props8.containerColor;

      var containerStyle = _objectSpread({}, this.getOverlayContainerStyle(), {
        padding: '2em',
        justifyContent: 'center',
        display: 'inline-block'
      });

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "hero-background ".concat(containerAs === 'solid' && containerColor),
        style: containerStyle
      }, this.renderHeaderContent());
    }
  }, {
    key: "renderOverlay",
    value: function renderOverlay() {
      var _this$props9 = this.props,
          images = _this$props9.images,
          showMultiple = _this$props9.showMultiple,
          containerAs = _this$props9.containerAs,
          overlay = _this$props9.overlay,
          parallax = _this$props9.parallax,
          width = _this$props9.width;
      var bannerProps = null;

      if (images) {
        bannerProps = images.length > 1 && showMultiple ? {
          as: 'carousel',
          backgroundImage: images[0],
          galleryImages: images,
          carouselOptions: {
            autoScroll: true
          }
        } : {
          as: 'banner',
          backgroundImage: images[0]
        };
      }

      return /*#__PURE__*/_react["default"].createElement(_ImageBanner["default"], (0, _extends2["default"])({
        header: this.renderOverlayContainer(),
        parallax: parallax,
        overlay: overlay && containerAs !== 'solid' ? 'dark' : 'none'
      }, bannerProps, {
        width: width
      }));
    }
  }, {
    key: "renderTiles",
    value: function renderTiles(items) {
      var _this2 = this;

      var gutter = this.props.gutter;
      return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid, {
        stackable: true,
        verticalAlign: "middle",
        columns: 2
      }, items.map(function (_ref) {
        var background = _ref.background,
            content = _ref.content,
            link = _ref.link,
            type = _ref.type;
        return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
          key: link,
          as: "a",
          href: link,
          width: type === 'image' ? 11 : 5,
          style: !gutter ? _this2.getColumnStyle(type, background) : {},
          className: "hero-background ".concat(background)
        }, /*#__PURE__*/_react["default"].createElement("div", {
          style: gutter ? _this2.getColumnStyle(type, background) : {}
        }, content));
      }));
    }
  }, {
    key: "renderTileHero",
    value: function renderTileHero() {
      var _this$props10 = this.props,
          containerColor = _this$props10.containerColor,
          textAlign = _this$props10.textAlign;
      var graphic = this.getBackgroundMetadata();
      var block = {
        background: containerColor,
        content: this.renderHeaderContent(),
        type: 'color'
      };
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
        className: "hero-element-desktop"
      }, textAlign === 'right' ? this.renderTiles([block, graphic]) : this.renderTiles([graphic, block])), /*#__PURE__*/_react["default"].createElement("span", {
        className: "hero-element-mobile"
      }, this.renderOverlay()));
    }
  }, {
    key: "renderImagelessHero",
    value: function renderImagelessHero() {
      var containerColor = this.props.containerColor;
      var imagelessStyle = {
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: '15%',
        display: 'flex',
        alignItems: 'center',
        textAlign: 'center',
        justifyContent: 'center',
        padding: '1em',
        backgroundColor: containerColor
      };
      return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid, {
        verticalAlign: "middle",
        columns: 1
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
        width: 16,
        style: imagelessStyle,
        className: "hero-background ".concat(containerColor)
      }, this.renderHeaderContent()));
    }
  }, {
    key: "render",
    value: function render() {
      if (this.requiresOnlyText()) {
        return this.renderImagelessHero();
      }

      return this.requiresOverlay() ? this.renderOverlay() : this.renderTileHero();
    }
  }]);
  return HeroElement;
}(_react["default"].Component);

exports["default"] = HeroElement;
HeroElement.propTypes = {
  header: _propTypes["default"].string.isRequired,
  tagline: _propTypes["default"].string,
  images: _propTypes["default"].arrayOf(_propTypes["default"].string),
  address: _propTypes["default"].shape({
    city: _propTypes["default"].string.isRequired,
    state: _propTypes["default"].string.isRequired,
    zip: _propTypes["default"].string.isRequired,
    country: _propTypes["default"].string,
    street: _propTypes["default"].string
  }),
  showMap: _propTypes["default"].bool,
  ctas: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    text: _propTypes["default"].string,
    link: _propTypes["default"].string,
    internal: _propTypes["default"].bool,
    color: _propTypes["default"].element,
    inverted: _propTypes["default"].string.isRequired,
    className: _propTypes["default"].string
  })),
  ctaColor: _propTypes["default"].string,
  ctaInverted: _propTypes["default"].bool,
  containerColor: _propTypes["default"].string,
  textColor: _propTypes["default"].string,
  textAlign: _propTypes["default"].oneOf(['left', 'right', 'center']),
  showMultiple: _propTypes["default"].bool,
  overlay: _propTypes["default"].bool,
  fullWidth: _propTypes["default"].bool,
  parallax: _propTypes["default"].bool,
  containerAs: _propTypes["default"].oneOf(['none', 'outline', 'solid']),
  height: _propTypes["default"].number,
  width: _propTypes["default"].number,
  gutter: _propTypes["default"].bool,
  internalLinkComponent: _propTypes["default"].element
};
HeroElement.defaultProps = {
  images: null,
  tagline: null,
  showMap: false,
  address: null,
  ctas: [],
  ctaColor: 'primary',
  ctaInverted: true,
  containerColor: 'primary',
  textColor: 'white',
  textAlign: 'center',
  showMultiple: true,
  overlay: true,
  fullWidth: true,
  parallax: true,
  containerAs: 'solid',
  height: 500,
  gutter: false,
  internalLinkComponent: null,
  width: 2000
};